import { chain } from 'lodash';
import { CATEGORY_IDENTIFIERS } from 'src/constants/dynamicFields';
import { auth as useAuthStore } from 'src/store/auth';

export default {
  clientDataFields: (state) => chain(state.clinicDataFields)
    .filter({ context: CATEGORY_IDENTIFIERS.CLIENT })
    .sortBy('order')
    .value(),

  staffMemberDataFields: (state) => chain(state.clinicDataFields)
    .filter({ context: CATEGORY_IDENTIFIERS.STAFF_MEMBER })
    .sortBy('order')
    .value(),

  staffMemberSystemDataFields: (state) => chain(state.clinicDataFields)
    .filter({ context: CATEGORY_IDENTIFIERS.STAFF_MEMBER_SYSTEM })
    .sortBy('order')
    .value(),

  allStaffMemberDataFields() {
    return [...this.staffMemberSystemDataFields, ...this.staffMemberDataFields];
  },

  clientDataFieldSections: (state) => chain(state.clinicDataFieldSections)
    .filter({ context: CATEGORY_IDENTIFIERS.CLIENT })
    .sortBy('order')
    .value(),

  staffMemberDataFieldSections: (state) => chain(state.clinicDataFieldSections)
    .filter({ context: CATEGORY_IDENTIFIERS.STAFF_MEMBER })
    .sortBy('order')
    .value(),

  staffMemberSystemDataFieldSections: (state) => chain(state.clinicDataFieldSections)
    .filter({ context: CATEGORY_IDENTIFIERS.STAFF_MEMBER_SYSTEM })
    .sortBy('order')
    .value(),

  clientSchedulingGroupsSection: (state) => state.clinicDataFieldSections.find((section) => {
    return section.context === CATEGORY_IDENTIFIERS.CLIENT && section.isDefaultSection;
  }) || null,

  clientSchedulingGroupsFields: (state) => state.clinicDataFields.filter((field) => {
    return field.context === CATEGORY_IDENTIFIERS.CLIENT && field.section === state.clientSchedulingGroupsSection?.id;
  }) || [],

  staffSchedulingGroupsSection: (state) => state.clinicDataFieldSections.find((section) => {
    return section.context === CATEGORY_IDENTIFIERS.STAFF_MEMBER && section.isDefaultSection;
  }) || null,

  staffSchedulingGroupsFields: (state) => state.clinicDataFields.filter((field) => {
    return (
      field.context === CATEGORY_IDENTIFIERS.STAFF_MEMBER
      && field.section === state.staffSchedulingGroupsSection?.id
    );
  }) || [],

  programDataFields: (state) => chain(state.clinicDataFields)
    .filter({ context: CATEGORY_IDENTIFIERS.PROGRAM })
    .sortBy('order')
    .value(),

  visibleProgramDataFields() {
    const auth = useAuthStore();
    const { showDefaultProgramDataFields } = auth;

    return this.programDataFields
      .filter((field) => !field.isDefaultDataField
        || (showDefaultProgramDataFields && field.isVisibleDataField));
  },

  programDataFieldSections: (state) => chain(state.clinicDataFieldSections)
    .filter({ context: CATEGORY_IDENTIFIERS.PROGRAM })
    .sortBy('order')
    .value(),
};
